import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#0A0A0B]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="mb-4">
              <img src="/logo.png" alt="Haus des Handys" className="h-14 w-auto" />
            </div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#FF2D40] font-bold mb-4">
              Erleben, was verbindet.
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed">
              Ihr persönlicher Smartphone-Experte in Wien. Reparatur, Beratung & Premium-Zubehör seit 2023.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.22em] font-semibold text-white mb-5">Services</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/reparaturen" className="hover:text-[#FF2D40] transition-colors">Display Reparatur</Link></li>
              <li><Link to="/reparaturen" className="hover:text-[#FF2D40] transition-colors">Akku Tausch</Link></li>
              <li><Link to="/reparaturen" className="hover:text-[#FF2D40] transition-colors">Kamera Reparatur</Link></li>
              <li><Link to="/reparaturen" className="hover:text-[#FF2D40] transition-colors">Wasserschaden</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.22em] font-semibold text-white mb-5">Shop</h4>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/zubehoer" className="hover:text-[#FF2D40] transition-colors">Handyhüllen</Link></li>
              <li><Link to="/zubehoer" className="hover:text-[#FF2D40] transition-colors">Displayschutz</Link></li>
              <li><Link to="/zubehoer" className="hover:text-[#FF2D40] transition-colors">Powerbanks</Link></li>
              <li><Link to="/refurbished" className="hover:text-[#FF2D40] transition-colors">Refurbished iPhones</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.22em] font-semibold text-white mb-5">Kontakt</h4>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-zinc-500 shrink-0" />
                <span>Hernalser Hauptstraße 135<br/>1170 Wien, Österreich</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-zinc-500" />
                <a href="tel:+436764440304" className="hover:text-[#FF2D40]">+43 676 4440304</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-zinc-500" />
                <a href="mailto:store@hausdeshandys.at" className="hover:text-[#FF2D40]">store@hausdeshandys.at</a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="w-4 h-4 text-zinc-500" />
                <a href="https://instagram.com/hausdeshandys" target="_blank" rel="noreferrer" className="hover:text-[#FF2D40]">@hausdeshandys</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-600">
          <div>© {new Date().getFullYear()} Haus des Handys. Alle Rechte vorbehalten.</div>
          <div className="flex flex-wrap gap-6">
            <Link to="/admin/login" className="hover:text-white transition-colors" data-testid="footer-admin-link">Admin</Link>
            <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-datenschutz">Datenschutz</Link>
            <Link to="/agb" className="hover:text-white transition-colors" data-testid="footer-agb">AGB</Link>
          </div>
        </div>

        {/* Subtle bottom credit */}
        <div className="mt-8 flex items-center justify-center gap-3 text-[11px] text-zinc-700" data-testid="footer-credit">
          <span>Made by</span>
          <a
            href="https://cloudservice.hr"
            target="_blank"
            rel="noreferrer"
            className="hover:text-zinc-300 transition-colors tracking-wide"
            data-testid="footer-credit-link"
          >
            cloudservice.hr
          </a>
          <span className="text-zinc-800">·</span>
          <a
            href="https://instagram.com/cloudservice.hr"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center hover:text-zinc-300 transition-colors"
            data-testid="footer-credit-instagram"
            aria-label="cloudservice.hr auf Instagram"
          >
            <Instagram className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
